import { render } from "./dpw-table.vue?vue&type=template&id=4d4c5d26&scoped=true"
import script from "./dpw-table.vue?vue&type=script&lang=js"
export * from "./dpw-table.vue?vue&type=script&lang=js"

import "./dpw-table.vue?vue&type=style&index=0&id=4d4c5d26&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4c5d26"]])

export default __exports__